import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import ProductOutOfStockModal from '@/modules/products/components/out-of-stock/ProductOutOfStockModal'
import ExtraLine from '@/modules/shared/components/table/ExtraLine'
import { Themes } from '@/modules/shared/types/Themes'

interface ProductOutOfStockWarningProps {
  productId: number
  outOfStock: boolean
}

export default function ProductOutOfStockWarning({ productId, outOfStock }: ProductOutOfStockWarningProps) {
  const { t } = useTranslation()
  const [showOutOfStockModal, setShowOutOfStockModal] = useState(false)

  return (
    <>
      {outOfStock && (
        <ExtraLine
          theme={Themes.Error}
          title={t('general.outOfStock', 'Out of Stock')}
          value={t('outOfStockWarning.description', 'This product is Out of Stock')}
          onLineClick={() => {
            setShowOutOfStockModal(true)
          }}
        />
      )}
      <ProductOutOfStockModal
        showModal={showOutOfStockModal}
        setShowModal={setShowOutOfStockModal}
        productId={productId}
      />
    </>
  )
}
